import WebsiteElement from "./WebsiteElement";

export default class FooterRow extends WebsiteElement {
    /**
     * @param {HTMLElement} element
     */
    constructor(element) {
        super(element);

        if (element.classList.contains('site-navigation')) {
            this.animateInTiming = 2000;
        }
    }

    /**
     * Kijkt of het element boven de onderkant van de viewport zit.
     *
     * @param {number} bottom
     *
     * @returns {boolean}
     */
    isAbove(bottom) {
        if (this._element.classList.contains('copyright') || this._element.classList.contains('linked-in')) {
            return (this._element.offsetTop <= bottom);
        }

        return ((this._element.offsetTop + 200) <= bottom);
    }

    /**
     * Kijkt of het element een instantie van dit object moet krijgen.
     *
     * @param {HTMLElement} element
     *
     * @return {boolean}
     */
    static is(element) {
        return element.parentElement.tagName === 'FOOTER';
    }
}